/**
 * Cleans a phone number string by removing all non-digit characters.
 * @param {string} phone
 * @returns {string} cleaned phone number (digits only)
 */
export function cleanPhone(phone) {
  return phone.replace(/\D/g, "");
}

/**
 * Validates a cleaned phone number.
 * @param {string} cleanedPhone
 * @returns {boolean} true if valid (between 10 and 15 digits), false otherwise
 */
export function isValidPhone(cleanedPhone) {
  return cleanedPhone.length >= 10 && cleanedPhone.length <= 15;
}